module.exports = __webpack_public_path__ + "media/images/icons/outlined/reconciliation-8b168377e15139ec7a1de66aebe36a5f.svg";